module.exports = __webpack_public_path__ + "img/POP-00016-2.7de27fe5.jpg";